import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { User } from 'app/auth/models';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';
import { OnelszamoloEgysegekService } from 'app/main/pages/torzsek/services/onelszamolo-egysegek.service';
import { findByProp, parseJSON, stringifyIfJSON } from 'app/main/pages/torzsek/utils';
import { coreConfig } from 'app/app-config';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  //public
  public currentUser$: Observable<User>;

  //private
  private _currentUser: BehaviorSubject<User>;

  /**
   *
   * @param {HttpClient} _http
   */
  constructor(
      private api: ApiService,
      private coreConfigService: CoreConfigService,
      private oeService: OnelszamoloEgysegekService
      ) {
    this._currentUser = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser$ = this._currentUser.asObservable();
  }

  // getter: currentUserValue
  public get currentUserValue(): any {
    return this._currentUser.value;
  }

  get accessToken(): string {
    return localStorage.getItem('accessToken') || null;
  }

  /**
   *  Confirms if user is admin
   */
  get isAdmin() {
    return (
      // this.currentUser && this.currentUserSubject.value.role === Role.Admin
      true
    );
  }

  /**
   *  Confirms if user is client
   */
  get isClient() {
    return (
      // this.currentUser && this.currentUserSubject.value.role === Role.Client
      false
    );
  }

  /**
   *  Updates current user state
   *  Updates current user in localStorage
   */
  set currentUser(user: User) {
    localStorage.setItem('currentUser', JSON.stringify(user));

    console.log('update localstorage', user)
    this._currentUser.next(user);
  }

  /**
   * User login
   *
   * @param felhasznalonev
   * @param jelszo
   * @returns user
   */
  login(felhasznalonev: string, jelszo: string) {
    return this.api
      .post(environment.auth, {
        felhasznalonev,
        jelszo,
      })
      .pipe(
        // tap((response) => console.log('Login response:', response)),
        map((user) => {
          let retUser: any;
          // login successful if there's a jwt token in the response
          if (user && user.token) {
            const parsed = {
              ...user,
              oek: parseJSON(user.oek),
              raktarak: parseJSON(user.raktarak),
              jogosultsagok: parseJSON(user?.jogosultsagok),
              config: parseJSON(user?.beallitasok),
              beallitasok: parseJSON(user?.beallitasok),
            };

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(parsed));
            localStorage.setItem('accessToken', user.token);
            localStorage.setItem('rows', JSON.stringify(100));

            // notify
            if(parsed.beallitasok?.user_settings?.oe && parsed.beallitasok?.user_settings?.raktar) {
              this.currentUser = {
                ...parsed,
                oe: parsed.beallitasok.user_settings.oe,
                raktar: parsed.beallitasok.user_settings.raktar,
              };

              retUser = {
                ...parsed,
                oe: parsed.beallitasok.user_settings.oe,
                raktar: parsed.beallitasok.user_settings.raktar,
              };

              // const configJSON = JSON.parse(localStorage.getItem('config'));

              // const config = {
              //   ...configJSON,
              //   user_settings: {
              //     oe: parsed.beallitasok.user_settings.oe,
              //     raktar: parsed.beallitasok.user_settings.raktar
              //   }
              // }

              // localStorage.setItem('config', stringifyIfJSON(config));
              // this.coreConfigService.config = config;
            } else {
              retUser = parsed;
              this.currentUser = parsed;
            }



            //this.currentUser = parsed;

          }

          return retUser;
        }),
        switchMap((user) => {
          // after login fetch the felhasznaloi_csoportok
          if (user && user.token) {
            console.log('user', user)
            return this.oeService.initData$
              .pipe(
                map((oek) => {
                  const oe_nev = findByProp(oek, 'id', user.oe)?.megnevezes || '';
                  const kulfoldi = findByProp(oek, 'id', user.oe)?.kulfoldi || '';

                  const updatedUser = {
                    ...user,
                    oeNev: oe_nev,
                    jogosultsagok: parseJSON(user.jogosultsagok),
                  };
  
                  // Update localStorage with the new user data including groups
                  localStorage.setItem('currentUser', JSON.stringify(updatedUser));

                  // Update currentUser with groups
                  this.currentUser = {
                    ...updatedUser,
                    oeNev: oe_nev,
                    kulfoldi_oe: kulfoldi,
                    jogosultsagok: parseJSON(user.jogosultsagok),
                  };
  
                  return updatedUser;
                })
              );
          }
          return of(user); // If login failed, just pass through the original user
        }),
        catchError((err) => {
          console.log('Login error:', err);

          return throwError(err);
        })
      );
  }

    /**
   * User login
   *
   * @param adoszam
   * @returns user
   */
    login_2(adoszam: string) {
      return this.api
        .postWithoutMsg('auth_ii', {
          adoszam,
        })
        .pipe(
          // tap((response) => console.log('Login response:', response)),
          map((user) => {
            let retUser: any;
            // login successful if there's a jwt token in the response
            if (user && user.token) {
              const parsed = {
                ...user,
                oek: parseJSON(user.oek),
                raktarak: parseJSON(user.raktarak),
                jogosultsagok: parseJSON(user?.jogosultsagok),
                config: parseJSON(user?.beallitasok),
                beallitasok: parseJSON(user?.beallitasok),
              };
  
              // store user details and jwt token in local storage to keep user logged in between page refreshes
              localStorage.setItem('currentUser', JSON.stringify(parsed));
              localStorage.setItem('accessToken', user.token);
              localStorage.setItem('rows', JSON.stringify(100));
  
              // notify
              if(parsed.beallitasok?.user_settings?.oe && parsed.beallitasok?.user_settings?.raktar) {
                this.currentUser = {
                  ...parsed,
                  oe: parsed.beallitasok.user_settings.oe,
                  raktar: parsed.beallitasok.user_settings.raktar,
                };
  
                retUser = {
                  ...parsed,
                  oe: parsed.beallitasok.user_settings.oe,
                  raktar: parsed.beallitasok.user_settings.raktar,
                };
  
                // const configJSON = JSON.parse(localStorage.getItem('config'));
  
                // const config = {
                //   ...configJSON,
                //   layout: {
                //     ...configJSON.layout,
                //     menu: {
                //       ...configJSON.layout.menu,
                //       hidden: true
                //     }
                //   },
                //   user_settings: {
                //     oe: parsed.beallitasok.user_settings.oe,
                //     raktar: parsed.beallitasok.user_settings.raktar
                //   }
                // }
  
                // localStorage.setItem('config', stringifyIfJSON(config));
                // this.coreConfigService.config = config;
              } else {
                retUser = parsed;
                this.currentUser = parsed;
              }
  
  
  
              //this.currentUser = parsed;
  
            }
  
            return retUser;
          }),
          switchMap((user) => {
            // after login fetch the felhasznaloi_csoportok
            if (user && user.token) {
              console.log('user', user)
              return this.oeService.initData$
                .pipe(
                  map((oek) => {
                    const oe_nev = findByProp(oek, 'id', user.oe)?.megnevezes || '';
  
                    const updatedUser = {
                      ...user,
                      oeNev: oe_nev,
                      jogosultsagok: parseJSON(user.jogosultsagok),
                    };
    
                    // Update localStorage with the new user data including groups
                    localStorage.setItem('currentUser', JSON.stringify(updatedUser));
  
                    // Update currentUser with groups
                    this.currentUser = {
                      ...updatedUser,
                      oeNev: oe_nev,
                      jogosultsagok: parseJSON(user.jogosultsagok),
                    };
    
                    return updatedUser;
                  })
                );
            }
            return of(user); // If login failed, just pass through the original user
          }),
          catchError((err) => {
            console.log('Login error:', err);
  
            return throwError(err);
          })
        );
    }

  /**
   * User logout
   *
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('accessToken');
          localStorage.clear();
          sessionStorage.clear();
          localStorage.setItem('config', stringifyIfJSON(coreConfig));

    // notify
    this._currentUser.next(null);
  }
}
